import { lazy } from 'react';

const loadContractRequestBigClientAdminPage = () => import('./ContractRequestBigClientAdminPage');
export const ContractRequestBigClientAdminPageLoad = lazy(loadContractRequestBigClientAdminPage);

const loadContractRequestStateAdminPage = () => import('./ContractRequestStateAdminPage');
export const ContractRequestStateAdminPageLoad = lazy(loadContractRequestStateAdminPage);

const loadContractRequestResidentialClientAdminPage = () => import('./ContractRequestResidentialClientAdminPage');
export const ContractRequestResidentialClientAdminPageLoad = lazy(loadContractRequestResidentialClientAdminPage);

const loadWriteContractRequestPage = () => import('./WriteContractRequestPage');
export const WriteContractRequestAdminPageLoad = lazy(loadWriteContractRequestPage);

const loadWriteContractRequestStatePage = () => import('./WriteContractRequestStatePage');
export const WriteContractRequestStatePageLoad = lazy(loadWriteContractRequestStatePage);

const loadWriteContractRequestResidentialClientPage = () => import('./WriteContractRequestResidentialClientPage');
export const WriteContractRequestAdminResidentialClientPageLoad = lazy(loadWriteContractRequestResidentialClientPage);

const loadContractRequestDetailPageLoad = () => import('./ContractRequestDetailPage');
export const ContractRequestDetailPageLoad = lazy(loadContractRequestDetailPageLoad);

const loadClientCodesPage = () => import('./ClientCodesPage');
export const ClientCodesPagePageLoad = lazy(loadClientCodesPage);
